import { createFileRoute, redirect } from '@tanstack/react-router';
import { getAuthStore } from '../main';
import { SpSidebar } from '../components/Sidebar';
import { Pane } from '@sheridan-prize/ui';
import { CategoryAdd } from '../components/CategoryAdd';

export const Route = createFileRoute('/categories_/add')({
  beforeLoad: async () => {
    await getAuthStore().fetchUser();
    const isAuthenticated = getAuthStore().getIsAuthenticated();

    if (!isAuthenticated) {
      throw redirect({ to: '/login' });
    }

    if (getAuthStore().getUser()?.role !== 'superadmin') {
      throw redirect({ to: '/' });
    }

    await getAuthStore().fetchUserDoc();
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <SpSidebar />
      <Pane tag="main" classes={'sp-main'}>
        <h1>Add Category</h1>
        <CategoryAdd />
      </Pane>
    </>
  );
}
